import { arrayMax, arrayMin } from "../../../omnia"
import { ICroppingBiomass } from "../../../types"

export function calculateCroppingAppRateManual(biomass: ICroppingBiomass, minRate: number, maxRate: number, rounding: number): number {

    let rate: number

    minRate = minRate || 0
    maxRate = maxRate || 0

    let minBiomassValue = arrayMin(biomass.Values, v => v.Value)
    let maxBiomassValue = arrayMax(biomass.Values, v => v.Value)

    let biomassRange = maxBiomassValue - minBiomassValue

    if ((!biomassRange) || (!biomass)) {

        rate = (minRate + maxRate) / 2

    }
    else {

        let rateRange = maxRate - minRate

        let totalAmount = biomass.Values.map(v => {

            const biomassValue = v.Value || 0

            let r = (minRate + (((biomassValue - minBiomassValue) / biomassRange) * rateRange))

            if (rounding) {
                r = Math.round(r / rounding) * rounding
            }

            r *= v.Area

            return r


        }).reduce((p, v) => v + p, 0)

        let totalArea = biomass.CroppingArea

        rate = totalAmount / totalArea

    }

    rate = Math.round(rate)

    return rate

}

